import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { formatCurrency } from '../utils/calculations';

const { FiShield, FiCheckCircle, FiCpu } = FiIcons;

function Hero({ lastSaved, total }) {
  return (
    <section className="hero">
      <div className="hero-gridline" />
      <div className="hero-copy">
        <div className="eyebrow">
          <SafeIcon icon={FiCpu} />
          Intelligent conference planning
        </div>
        <h1>
          Build a sharper,
          <span>future-ready</span> advertising budget.
        </h1>
        <p>
          Model every media placement, sponsorship, production cost, and reserve
          before presenting your plan to leadership.
        </p>
        <div className="hero-proof">
          <SafeIcon icon={FiShield} />
          <span>Built for transparent medical society planning</span>
        </div>
      </div>

      <div className="hero-status">
        <div className="status-orbit" />
        <div className="status-content">
          <span>Current plan</span>
          <strong>{formatCurrency(total)}</strong>
          <div className="save-state">
            <SafeIcon icon={FiCheckCircle} />
            <span>Saved locally {lastSaved}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;